export default "__VITE_ASSET__BFiXICPt__"